export default function ProgressBar({ current, total }) {
  const progress = (current / total) * 100;

  return (
    <div className="flex items-center gap-3">
      <div className="w-24 sm:w-32 h-2 bg-[#1E293B] rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-[#22D3EE] to-[#60A5FA] rounded-full transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      <span className="text-[#64748B] text-sm font-medium whitespace-nowrap">
        {current}/{total}
      </span>
    </div>
  );
}
